import { useState } from 'react';
import { useNavigate, Link } from 'react-router';
import { Eye, EyeOff } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { getPasswordIssue, PASSWORD_MIN_LENGTH } from '../auth/passwordStrength';
import '../styles/AuthPage.css';
import logo from '../logo.png';

export default function RegisterPage() {
  const { signUp } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ fullName: '', email: '', password: '', phone: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const passwordIssue = form.password
    ? getPasswordIssue(form.password, {
      phone: form.phone,
      email: form.email,
      fullName: form.fullName,
    })
    : '';

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (passwordIssue) return;
    setLoading(true);
    const { error: signUpError } = await signUp(form);
    setLoading(false);
    if (signUpError) {
      setError(signUpError.message?.includes('already')
        ? 'این ایمیل قبلاً ثبت شده است'
        : 'ثبت‌نام ناموفق بود، دوباره تلاش کنید');
      return;
    }
    navigate('/', { replace: true }); // -> /pending via RootRedirect
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-container">
        <img src={logo} alt="لوگو سایت" className="auth-logo" />
        <h2>ثبت‌نام اپراتور</h2>
        <form className="auth-form-group" onSubmit={onSubmit}>
          <div className="auth-input-wrapper">
            <input className="auth-input" placeholder="نام و نام خانوادگی"
              value={form.fullName} onChange={set('fullName')} required autoFocus />
          </div>
          <div className="auth-input-wrapper">
            <input className="auth-input" type="email" dir="ltr" placeholder="ایمیل"
              value={form.email} onChange={set('email')} required />
          </div>
          <div className="auth-input-wrapper auth-input-wrapper--eye">
            <input className="auth-input" type={showPassword ? 'text' : 'password'} dir="ltr" placeholder="رمز عبور"
              value={form.password} onChange={set('password')} minLength={PASSWORD_MIN_LENGTH}
              aria-invalid={Boolean(passwordIssue)} aria-describedby="register-password-help" required />
            <button type="button" className="auth-input-eye"
              onClick={() => setShowPassword((v) => !v)}
              aria-label={showPassword ? 'پنهان کردن رمز عبور' : 'نمایش رمز عبور'}>
              {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>
          {passwordIssue && (
            <div id="register-password-help" role="status" aria-live="polite"
              style={{ color: '#b91c1c', fontSize: 13, margin: '0 0 6px', lineHeight: 1.7 }}>
              {passwordIssue}
            </div>
          )}
          <div className="auth-input-wrapper">
            <input className="auth-input" type="tel" dir="ltr" placeholder="09121234567 (اختیاری)"
              value={form.phone} onChange={set('phone')} />
          </div>
          {error && <div style={{ color: '#dc2626', fontSize: 13, margin: '6px 0' }}>{error}</div>}
          <button className="auth-button" type="submit" disabled={loading}>
            {loading ? 'در حال ثبت‌نام…' : 'ثبت‌نام'}
          </button>
        </form>
        <div style={{ marginTop: 12, fontSize: 12, color: '#475569', lineHeight: 1.7 }}>
          پس از ثبت‌نام، حساب شما باید توسط ادمین تأیید شود.
        </div>
        <div style={{ marginTop: 10, fontSize: 13 }}>
          <Link to="/login" style={{ color: '#2563eb', fontWeight: 600 }}>حساب دارید؟ ورود</Link>
        </div>
      </div>
    </div>
  );
}
